import React, { useState, useEffect } from 'react';
import authService from './api-authorization/AuthorizeService'
import axios from 'axios'
import { ThreeDots } from "react-loader-spinner";
import Modal from '@mui/material/Modal';
import "bootstrap/dist/css/bootstrap.min.css"; //https://www.creative-tim.com/blog/web-design/how-to-use-bootstrap-with-reactjs/
import { Box, Grid, Button, Stack, TextField, FormControlLabel, Checkbox, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MUIDataTable, { ExpandButton } from "mui-datatables";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import PreviewIcon from '@mui/icons-material/Preview';
import PGNViewer from './PGNViewer';
import { Link} from 'react-router-dom'

const muiCache = createCache({
    key: 'mui-datatables',
    prepend: true,
});

//https://surajsharma.net/blog/react-upload-file-using-axios
const MAX_PGNFILE_SIZE_ = 500000;

export default function UploadPGN({ label,updateFilesCb,maxFileSizeInBytes = MAX_PGNFILE_SIZE_,...otherProps })
{
    const [token, setToken] = useState("");
    const [skipUnfinishedGames, setSkipUnfinishedGames] = useState(true);
    const [uploadStatus, setUploadStatus] = useState("");
    const [status, setStatus] = useState("");
    const [uploadRecords, setUploadRecords] = useState([]);
    const [pgnFile, setPgnFile] = useState(null);
    const [waiting, setWaiting] = useState(false);
    const [gamePGNString, setGamePGNString] = useState([]);
    const [gameKey, setGameKey] = useState("");
    const [gameSource, setGameSource] = useState("");
    const [uscfEventID, setUscfEventID] = useState("");
    const [fideEventID, setFideEventID] = useState("");
    const [tournament, setTournament] = useState("");
    const [open, setOpen] = useState(false);

    const handleClose = () => setOpen(false);

    const columns = [
        {
            name: '',
            label: '',
            options: {
                filter: false,
                display: true,
                viewColumns: false,
                customBodyRender: (value, tableMeta, update) => {
                    let rowIndex = Number(tableMeta.rowIndex) + 1;
                    return (
                        <div style={{ textAlign: "right" }}><span>{rowIndex}</span></div>
                    )
                }
            }
        },
        {
            name: "status",
            label: "Status",
            options: {
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div style={{ textAlign: "center" }}>{value}</div>
                )
            }
        },
        {
            name: "event",
            label: "Event",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                setCellProps: () => ({ style: { whiteSpace: "nowrap", width: "200px" } }),
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                        {columnMeta.label}
                    </th>
                ),
            }
        },
        {
            name: "white",
            label: "White",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "100px" }}>
                        {columnMeta.label}
                    </th>
                ),
                //setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "right", minWidth: "100px", maxWidth:"100px", overflow: "hidden", textOverflow: "ellipsis",} }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let game = uploadRecords[originalIndex];
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left",
                    };

                    return (
                        <div style={{ position: "relative", height: "20px", width: "120px" }} title={value}>
                            <div style={parentStyle}>
                                <div style={cellStyle} title={value}>{game.whiteUSCFID !== -1 ? (<a href={'/players/details?idtype=USCF&id=' + game.whiteUSCFID} target='_blank' rel='noreferrer'>{value}</a>) :
                                    (game.whiteFIDEID !== -1 ? (<a href={'/players/details?idtype=FIDE&id=' + game.whiteFIDEID} target='_blank' rel='noreferrer'>{value}</a>) : value)}</div>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
            name: "whiteUSCFID",
            label: "USCF ID",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "100px" }}>
                        {columnMeta.label}
                    </th>
                ),
                //setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "right", minWidth: "100px", maxWidth:"100px", overflow: "hidden", textOverflow: "ellipsis",} }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let game = uploadRecords[originalIndex];
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left",
                    };

                    return (
                        <div style={{ position: "relative", height: "20px", width: "120px" }} title={value}>
                            <div style={parentStyle}>
                                <div style={cellStyle} title={value}><a href={'https://ratings.uschess.org/player/' + game.whiteUSCFID} target='_blank' rel='noreferrer'>{value}</a></div>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
            name: "whiteFIDEID",
            label: "FIDE ID",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "100px" }}>
                        {columnMeta.label}
                    </th>
                ),
                //setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "right", minWidth: "100px", maxWidth:"100px", overflow: "hidden", textOverflow: "ellipsis",} }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let game = uploadRecords[originalIndex];
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left",
                    };

                    return (
                        <div style={{ position: "relative", height: "20px", width: "120px" }} title={value}>
                            <div style={parentStyle}>
                                <div style={cellStyle} title={value}><a href={'https://ratings.fide.com/profile/' + game.whiteFIDEID} target='_blank' rel='noreferrer'>{value}</a></div>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
            name: "result",
            label: "Result",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th style={{ textAlign: "left", whiteSpace: "nowrap", width: "20px" }}>
                        {columnMeta.label}
                    </th>
                ),
                setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left" } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let game = uploadRecords[originalIndex];
                    if (game.status !== "Skipped-Unfinished") {
                        return (
                            <div>
                                <span style={{ textAlign: "left" }} onClick={async (e) => { await viewGame(e, game.gameHash) }}> <PreviewIcon /></span>
                                <Button component={Link} target="_blank" to={'/games/GameByID/' + game.gameHash} variant="text" color="primary">
                                    {value}
                                </Button>
                            </div>
                        );
                    }
                    else {
                        return (
                            <div>
                                    {value}
                            </div>
                        );
                    }
                        
                }
            }
        },
        {
            name: "black",
            label: "Black",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "100px" }}>
                        {columnMeta.label}
                    </th>
                ),
                //setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left", minWidth: "100px", maxWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", boxSizing: "border-box", } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left"
                    };
                    let game = uploadRecords[originalIndex];
                    return (
                        <div style={{ position: "relative", height: "20px", width: "120px" }} title={value}>
                            <div style={parentStyle}>
                                <div title={value} style={cellStyle}>
                                    {game.blackUSCFID !== -1 ? (<a href={'/players/details?idtype=USCF&id=' + game.blackUSCFID} target='_blank' rel='noreferrer'>{value}</a>) :
                                        (game.blackFIDEID !== -1 ? (<a href={'/players/details?idtype=FIDE&id=' + game.blackFIDEID} target='_blank' rel='noreferrer'>{value}</a>) : value)}
                                </div>
                            </div>
                        </div>
                    );
                }
            }
        },

        {
            name: "blackUSCFID",
            label: "USCF ID",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "100px" }}>
                        {columnMeta.label}
                    </th>
                ),
                //setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "right", minWidth: "100px", maxWidth:"100px", overflow: "hidden", textOverflow: "ellipsis",} }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let game = uploadRecords[originalIndex];
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left",
                    };

                    return (
                        <div style={{ position: "relative", height: "20px", width: "120px" }} title={value}>
                            <div style={parentStyle}>
                                <div style={cellStyle} title={value}><a href={'https://ratings.uschess.org/player/' + game.blackUSCFID} target='_blank' rel='noreferrer'>{value}</a></div>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
            name: "blackFIDEID",
            label: "FIDE ID",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "100px" }}>
                        {columnMeta.label}
                    </th>
                ),
                //setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "right", minWidth: "100px", maxWidth:"100px", overflow: "hidden", textOverflow: "ellipsis",} }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let game = uploadRecords[originalIndex];
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left",
                    };

                    return (
                        <div style={{ position: "relative", height: "20px", width: "120px" }} title={value}>
                            <div style={parentStyle}>
                                <div style={cellStyle} title={value}><a href={'https://ratings.fide.com/profile/' + game.blackFIDEID} target='_blank' rel='noreferrer'>{value}</a></div>
                            </div>
                        </div>
                    );
                }
            }
        },

        {
            name: "gameHash",
            label: "Game Hash",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true,
                setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "center" } }),
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                        {columnMeta.label}
                    </th>
                )
            }
        },
    ];

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'standard',
        expandableRows: false,
        selectableRows: 'none',
        expandableRowsOnClick: false,
        expandableRowsHeader: false,
        download: false,
        print: false,
        rowsPerPage: 10,
        rowsPerPageOptions: [5, 10, 15, 25, 50, 100, 200],
        jumpToPage: true,
        fixedHeaderOptions: {
            xAxis: true,
            yAxis: true
        },
        resizableColumns: false,
        isRowExpandable: (dataIndex, expandedRows) => {
            // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
            if (expandedRows.data.length > 4 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0)
                return false;
            return true;
        },
        rowsExpanded: [],
        onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) =>
            console.log(curExpanded, allExpanded, rowsExpanded),
    };

    const theme = createTheme({
        overrides: {
            MUIDataTableSelectCell: {
                expandDisabled: {
                    // Soft hide the button.
                    visibility: 'hidden',
                },
            },
        },
    });

    const components = {
        ExpandButton: function (props) {
            return <ExpandButton {...props} />;
        },
    };

    useEffect(() => {
        async function runOnce() {
            setToken(await authService.getAccessToken());
        }
        runOnce();
    }, []); 

        const upload = async (event) => {
        event.preventDefault()
        const formData = new FormData();
        formData.append("pgnFile", pgnFile);
        formData.append("gameSource", gameSource);
        formData.append("tournament", tournament);
        formData.append("uscfEventID", uscfEventID);
        formData.append("fideEventID", fideEventID);
        formData.append("skipUnfinishedGames", skipUnfinishedGames);

        setToken(await authService.getAccessToken());
        var ttt = await authService.getAccessToken();
        
        setWaiting(true);
        
        axios({
            method: "post",
            url: "/api/ChessGames/uploadPGN",
            data: formData,
            headers: {"Content-Type": "multipart/form-data", 'Authorization': `Bearer ${ttt}` },
        }).then(function (response) {
            if (response && response.data && response.data.gameUploadRecords) {
                setUploadStatus(response.data.message);
                const arrrr = Array.isArray(response.data.gameUploadRecords) ? response.data.gameUploadRecords : [];
                setUploadRecords(arrrr);
                setWaiting(false);
                console.log(response);
            }
            else {
                setUploadStatus("Unexpected response format");
            }

        })
        .catch(function (error) {
            console.log(error)
            setUploadStatus(error.response.data);
            setWaiting(false);
            });
    }

    const handleFileSelect = (e) => {
        setPgnFile(e.target.files[0]);
        var tagName = e.target.files[0].name;
        tagName = tagName.replace(/\s*\(.*?\)\s*/g, '');
        tagName = tagName.replace(/\.[^/.]+$/, "").slice(0, 64)
        setGameSource(tagName)
    }

    async function viewGame(e, gameHash) {
        e.preventDefault();
        var headers = {
            headers: { 'Authorization': `Bearer ${token}` }
        }
        setWaiting(true);
        await axios.get('/api/chessgames/getSingleGame?gamehash=' + gameHash, headers).then((response) => {
            const pgnString = response.data;
            setGamePGNString(pgnString);
            setGameKey(gameHash);
            setWaiting(false);
            setOpen(true);
        }).catch((error) => {
            setWaiting(true);
            setStatus(error.response.data);
            console.log(error.response.data);
        });
    };

    return (
        <div className="Container" style={{ position: 'relative' }}>
            <Accordion m={2} pt={3} pl={3} pr={3} defaultExpanded={true}>
                <AccordionSummary aria-controls="event-info" id="event-info" expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#1976d2' }}>
                    <Typography color='white'>Upload Game PGN</Typography>
                </AccordionSummary>
                <AccordionDetails>
                <form onSubmit={upload}>
                    <Box sx={{ pt: 2, pb: 1 }}>

                        <Grid container direction="row" rowSpacing={1} columnSpacing={1} justify-content="space-between" align-items="stretch">
                            <Grid item xs={12} lg={6}>
                                <div className="input-group">
                                    <div className="input-group-prepend" >
                                        <span className="input-group-text w-100 " id="inputGroupFileAddon01">PGN File</span>
                                    </div>
                                    <div className="custom-file">
                                        <input type="file" className="custom-file-input" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01" onChange={handleFileSelect} />
                                        <label className="custom-file-label" htmlFor="inputGroupFile01">{pgnFile != null ? pgnFile.name : "Choose a PGN file"}</label>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={12} lg={4}>
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text w-100" id="basic-addon1">Tag</span>
                                    </div>
                                    <input type="text" className="form-control" placeholder="Required. E.g. PNWCCG6020220130" aria-label="Tag" aria-describedby="basic-addon1" value={gameSource} onChange={async (e) => { await setGameSource(e.target.value.trim()) }}/>
                                </div>
                            </Grid>
                            <Grid item xs={12} lg={2}>
                                <Button type="submit" variant="contained" fullWidth disabled={waiting} value={waiting ? "Uploading..." : "   Upload   "}>Upload</Button>
                            </Grid>
                            <Grid item xs={12} lg={5}>
                                <div className="input-group mb-3">
                                <TextField
                                    size="small"
                                    fullWidth
                                    id="outlined-number"
                                    label={"Overwrite Tournament Name (Optional)"}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    value={tournament}
                                    onChange={async (e) => { await setTournament(e.target.value) }}
                                />
                                </div>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <Stack>
                                <FormControlLabel fullwidth="true" control={<Checkbox checked={skipUnfinishedGames} onChange={async (e) => { setSkipUnfinishedGames(e.target.checked) }} />} label={"Skip Unfinished Games"} />
                            </Stack>
                        </Grid>
                            <Grid item xs={12} lg={2}>
                                <div className="input-group mb-3">
                                <TextField
                                    size="small"
                                    fullWidth
                                    id="outlined-number"
                                    label={"USCF Event ID"}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    value={uscfEventID}
                                    onChange={async (e) => { await setUscfEventID(e.target.value.trim()) }}
                                />
                                </div>
                            </Grid>
                            <Grid item xs={12} lg={2}>
                                <div className="input-group mb-3">
                                <TextField
                                    size="small"
                                    fullWidth
                                    id="outlined-number"
                                    label={"FIDE Event ID"}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    value={fideEventID}
                                    onChange={async (e) => { await setFideEventID(e.target.value.trim()) }}
                                />
                                </div>
                                </Grid>
                                

                        </Grid>
                    </Box>
                            {waiting &&
                                <div style={{ zIndex: 99, position: 'absolute', top: 0, left: '30%' }}>
                                    <span> <ThreeDots ariaLabel="waiting " color="#00BFFF" /></span>
                                </div>
                    }
                    {Array.isArray(uploadRecords) && uploadRecords.length === 0 && uploadStatus !== "" &&
                        (<span>{uploadStatus}</span>)
                    }

                        <div className="mt-10 mb-10">
                            <CacheProvider value={muiCache}>
                                <ThemeProvider theme={theme}>
                                    <div style={{ display: Array.isArray(uploadRecords) && uploadRecords.length > 0 ? "block" : "none" }}>
                                        <MUIDataTable
                                            title={
                                                <div>
                                                    <span>{uploadStatus}</span>
                                                    <Button
                                                        variant="contained"
                                                        color="secondary"
                                                        onClick={() => {
                                                            setUploadRecords([]); // Clear records
                                                            setUploadStatus("");  // Reset status
                                                        }}
                                                    >
                                                        {"Clear Results"}
                                                    </Button>
                                                </div>
                                            }
                                            data={uploadRecords}
                                            columns={columns}
                                            options={options}
                                            components={components}
                                        />
                                    </div>
                                    {(!Array.isArray(uploadRecords) || uploadRecords.length === 0) && (
                                        <div className="placeholder">Select a PGN file to upload.</div>
                                    )}
                                </ThemeProvider>
                            </CacheProvider>
                        </div>


                </form>
                <Modal style={{
                        //"width": "600",
                        //"height": "600",
                        "position": "absolute",
                        /*"top": "5%",*/
                        //"left": "50%",
                        //"transform": "translate(-50%, -50%)",
                        "bgcolor": "background.paper",
                        /*"border": "2px solid #000",*/
                        "boxShadow": "24",
                        "p": "4",
                        "alignItems": "center",
                        "justifyContent": "center",
                        display: 'flex',
                    }}
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box style={{ "backgroundColor": "white", "padding": "10px" }}>
                            <div sytle={{ "alignItems": "right" }}>
                                <button className="btn btn-warning" onClick={handleClose}>Close</button>
                            </div>
                            <div>
                                <PGNViewer pgn={gamePGNString} key={gameKey} size={480} />
                            </div>
                        </Box>
                    </Modal>
                </AccordionDetails>
                </Accordion>
            </div>
            )
        
}
